<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <day-z-report-popup ref="dayZReportPopup"></day-z-report-popup>
    <vs-table id="orderLogsTable" :max-items="itemsPerPage" :data="dayReports" v-model="selected">
      <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
              vs-align="center"
            >
              <vs-row vs-type="flex" vs-w="12" vs-align="center">
                <vs-col vs-type="flex" class="w-auto mr-2">
                  <vx-tooltip text="Detaylı Filtreleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vs-button
                    @click="openTodayZReport"
                    color="success"
                    class="panel-action-box-shadow font-semibold"
                    icon-pack="feather"
                    icon="icon-file-text"
                  >
                    Bugünün Raporu
                  </vs-button>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-type="flex" vs-w="12">
                      <vs-col vs-type="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <feather-icon
                          v-if="chip.value === true"
                          icon="CheckIcon"
                          svgClasses="w-4 h-4 text-primary"
                        />
                        <feather-icon
                          v-else-if="chip.value === false"
                          icon="XIcon"
                        />
                        <span
                          v-else
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-1/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('id')"
            >Id
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'date' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('date')"
            >Rapor Tarihi
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'branchId' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('branchId')"
            >Şube
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'totalGiroReport' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('totalGiroReport')"
            >Brüt Toplam Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-3/12 px-1">
          <vs-button
            class="p-1 weight-600"
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'totalGiro' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('totalGiro')"
            >Net Toplam Tutar
          </vs-button>
        </vs-th>
        <vs-th class="w-2/12 px-1 text-center">İşlem</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="w-1/12 text-center">
            {{ tr.id }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.dateString }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ tr.branchName }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            {{ $toCurrency(tr.totalGiroReport || 0) }}
          </vs-td>
          <vs-td class="w-3/12 text-center">
            {{ $toCurrency(tr.totalGiro || 0) }}
          </vs-td>
          <vs-td class="w-2/12 text-center">
            <vs-button
              size="small"
              color="primary"
              @click.stop="openZReport(tr)"
              icon-pack="feather"
              icon="icon-file-text"
            >
              Z Raporu Oku
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-row vs-type="flex" vs-w="12">
      <pagination-default
        :setCurrentPage="tableOptions.pageIndex"
        :totalLenght="calculatePageLength"
        @currentPage="getCurrentPage"
      ></pagination-default>
    </vs-row>
  </div>
</template>

<script>
import PaginationDefault from "../../PaginationDefault";
import { getDayReports, getById } from "@/api/DayOpen";
import GlobalFilter from "../../GlobalFilter";
import DayZReportPopup from "./DayZReportPopup.vue";
import { isGranted } from "@/utils/auth";
import { GetTotalsOfSales, GetTotalsOfSalesForDealer } from "@/api/Reports.js";
import { getDiscountList, getDiscountListForDealer } from "@/api/Discount.js";

export default {
  data() {
    return {
      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,
      totalDataRow: 0,
      dayReports: [],
      isFilterActive: false,
      filterOptions: [
        "dateRange",
        "branch"
      ],
      filterOptionNames: [
        "Tarih",
        "Şube"
      ],
      isFiltererOpen: false,
      filterChips: [],
      selected: ""
    };
  },
  components: {
    PaginationDefault,
    GlobalFilter,
    DayZReportPopup
  },
  computed: {
    isDiffrencePermission() {
      return isGranted("day_report_diffrence_read");
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    }
  },
  methods: {
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Created",
        sortDirection: "desc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        dateRange: {
          startDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
          endDate:
            this.$now().getHours() >= 0 && this.$now().getHours() <= 2
              ? this.$preDate()
              : this.$now.date(),
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
        paymentMethod: null,
        extra: null,
        product: null,
        personal: null,
        order: null,
        price: {
          min: null,
          max: null,
        },
        branch: this.$currentUser.branch,
        dayReportType: { id: 2 }
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    parseReportDates(dateString) {
      if (!dateString) {
        return { startDate: new Date(), endDate: new Date() };
      }
      let dateParts = [];
      if (dateString.includes('.')) {
        dateParts = dateString.split('.');
      } else if (dateString.includes('/')) {
        dateParts = dateString.split('/');
      } else if (dateString.includes('-')) {
        dateParts = dateString.split('-');
      }

      let repDate = new Date();
      if (dateParts.length === 3) {
        repDate = new Date(dateParts[2], parseInt(dateParts[1]) - 1, dateParts[0]);
      }
      repDate.setHours(0, 0, 0, 0);

      let endD = new Date(repDate);
      endD.setHours(23, 59, 59, 999);

      return { startDate: repDate, endDate: endD };
    },
    getBranchPayload(report) {
      const branchId = report.branchId 
        || (report.branch ? report.branch.id : null) 
        || (this.$currentUser && this.$currentUser.branch ? this.$currentUser.branch.id : null)
        || (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);
      return branchId ? { id: branchId } : null;
    },
    getDayreport() {
      getDayReports(this.tableOptions)
        .then((res) => {
          if (res && res.status == 200) {
            const items = res.data.items || [];
            items.forEach((item) => {
              this.$set(item, "totalGiroReport", item.totalGiroReport || 0);
              this.$set(item, "totalGiro", item.totalGiro || 0);
              
              getById(item.id)
                .then((detailRes) => {
                  if (detailRes && detailRes.status == 200 && detailRes.data) {
                    const report = detailRes.data;
                    if (report.type == 2) {
                      this.$set(item, "totalGiroReport", report.totalGiroReport || 0);
                      this.$set(item, "totalGiro", report.totalGiro || 0);
                    } else {
                      const dates = this.parseReportDates(report.dateString);
                      const branchPayload = this.getBranchPayload(report);
                      const salesPayload = {
                        branch: branchPayload,
                        dateRange: {
                          startDate: dates.startDate,
                          endDate: dates.endDate
                        },
                        timeRange: {
                          startTime: { HH: '00', mm: '00' },
                          endTime: { HH: '23', mm: '59' }
                        }
                      };

                      const totalsApi = this.$isRegionalCenterBranch() ? GetTotalsOfSalesForDealer : GetTotalsOfSales;
                      const discountsApi = this.$isRegionalCenterBranch() ? getDiscountListForDealer : getDiscountList;

                      Promise.all([
                        totalsApi(salesPayload),
                        discountsApi({
                          ...salesPayload,
                          pageIndex: 0,
                          pageSize: 1000
                        })
                      ]).then(([salesRes, discountRes]) => {
                        let salesTotal = 0;
                        let discountTotal = 0;
                        if (salesRes && salesRes.status == 200 && salesRes.data) {
                          salesTotal = salesRes.data.totalAmount || 0;
                        }
                        if (discountRes && discountRes.status == 200 && discountRes.data) {
                          discountTotal = discountRes.data.totalAmount || 0;
                        }
                        this.$set(item, "totalGiroReport", salesTotal + discountTotal);
                        this.$set(item, "totalGiro", salesTotal);
                      }).catch(err => {
                        console.error("Live sales calculation error:", err);
                      });
                    }
                  }
                })
                .catch((err) => {
                  console.error("Z Raporu detay yükleme hatası:", err);
                });
            });
            this.dayReports = items;
            this.totalDataRow = res.data.totalCount;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Hata : " + res.status,
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Z Raporları Yüklenemedi ! ",
          });
        });
    },
    openZReport(tr) {
      this.$vs.loading();
      getById(tr.id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$refs.dayZReportPopup.theReport = res.data;
            this.$refs.dayZReportPopup.isActive = true;
          } else {
            this.$vs.notify({ color: "danger", title: "Hata", text: "Rapor getirilemedi" });
          }
        })
        .catch(() => {
          this.$vs.notify({ color: "danger", title: "Hata", text: "Bağlantı hatası" });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    openTodayZReport() {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const yyyy = today.getFullYear();
      const dateString = `${dd}.${mm}.${yyyy}`;

      let selectedBranch = this.tableOptions.branch || this.$currentUser.branch;

      const mockReport = {
        id: 0,
        dateString: dateString,
        userName: this.$currentUser ? this.$currentUser.name : "Test Kullanıcısı",
        branchName: selectedBranch ? selectedBranch.name : (this.$currentUser && this.$currentUser.branch ? this.$currentUser.branch.name : "Tüm Şubeler"),
        branchId: selectedBranch ? selectedBranch.id : (this.$currentUser && this.$currentUser.branch ? this.$currentUser.branch.id : null),
        openCountingAmount: 0,
        totalSafeCashEntriesPrice: 0,
        totalExpense: 0,
        instantCashBalance: 0,
        type: 2
      };

      this.$refs.dayZReportPopup.theReport = mockReport;
      this.$refs.dayZReportPopup.isActive = true;
    },
  },
  watch: {
    tableOptions: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.getDayreport();
        });
      },
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    selected(val) {
      if (val != "") {
        this.openZReport(val);
        this.selected = "";
      }
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
  created: function () {
    this.clearFilter();
    if (!this.$isCenterBranch()) {
      if (!this.$isRegionalCenterBranch()) {
        let branchPropIndex = this.filterOptions.indexOf("branch");
        this.filterOptions.splice(branchPropIndex, 1);
        this.filterOptionNames.splice(branchPropIndex, 1);
        delete this.tableOptions["branch"];
      }
    }
  },
};
</script>

<style>
#orderLogsTable .con-tablex {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>
